import { useState } from 'react';
import { download } from '../common/DownloadFileController/downloadFile';
import { MODEL_TYPES } from '../constants/constants';
import { errorToast, successToast } from '../helpers/toastHelper';
import { useModelActions } from './useModelActions';
import { paginatedImagineAISelector, paginatedImagineAISelectors } from '../redux/slicers/admin/paginatedImagineAI';
import { deleteImagineAIAPI, updateImagineAIAPI } from '../api/imagineai';
import { useCopyToClipboard } from 'react-use';
import { getExtensionFromURL, removeUndefinedText } from '../helpers/jsHelper';

export const useImagineAIActions = ({ item }) => {
  const [state, copy] = useCopyToClipboard();
  const { downloadImagineAI, downloadLoading } = useDownloadImagineAI();

  const deleteTitle = item.is_main_render
    ? 'Are you sure you want to archive this AI image?'
    : 'Are you sure you want to delete this AI image?';

  const deleteDescription = item.is_main_render
    ? 'You can view the archived AI image through filter panel.'
    : 'Deleted items will be moved to trash.';

  const cancelButtonText = item.is_main_render ? 'Cancel' : 'Cancel';
  const okButtonText = item.is_main_render ? 'Archive' : 'Delete';
  const okBtnColor = 'warning';
  const cancelBtnColor = 'secondary';
  const okBtnClassName = item.is_main_render ? 'lf-btn-3' : undefined;
  const deleteSuccessMessage = item.is_main_render
    ? 'Archived successfully'
    : 'Deleted successfully';

  const { favouriteLoading, onFavouriteToggle, onDelete, addToCollection } = useModelActions({
    item,
    updateApi: updateImagineAIAPI,
    modelType: MODEL_TYPES.IMAGINE_AI,
    selectors: paginatedImagineAISelectors,
    deleteSuccessMessage: deleteSuccessMessage,
    deleteConfig: {
      deleteApi: deleteImagineAIAPI,
      title: deleteTitle,
      description: deleteDescription,
      cancelButtonText,
      buttonText: okButtonText,
      okBtnColor,
      cancelBtnColor,
      okBtnClassName,
    },
  });

  const copyPrompt = (e) => {
    if (typeof e !== 'number' && typeof e !== 'string') {
      e?.preventDefault();
      e?.stopPropagation();
    }
    const text = removeUndefinedText(item?.text_prompt) || item?.name;
    copy(text);
    successToast('Copied!');
  };

  return {
    onDelete,
    onFavouriteToggle,
    favouriteLoading,
    downloadImagineAI,
    downloadLoading,
    addToCollection,
    copyPrompt,
  };
};

export const useDownloadImagineAI = () => {
  const [loading, setLoading] = useState(false);

  const downloadImagineAI = async (item) => {
    if (loading) return;
    setLoading(true);
    await downloadFile({
      name: getImagineAIDownloadName(item),
      url: item?.url,
    });
    setLoading(false);
  };

  return { downloadImagineAI, downloadLoading: loading };
};

const getImagineAIDownloadName = (item = {}) => {
  const extension = (getExtensionFromURL(item?.url) || '.png').toLowerCase();
  const cleanName = `${item?.name || 'imagineai_asset'}`
    .trim()
    .replace(/[\\/:*?"<>|]/g, '_')
    .replace(/\s+/g, '_')
    .slice(0, 50);
  const idPrefix = item?.id ? `${item.id}_` : '';
  const baseName = `${idPrefix}${cleanName || 'imagineai_asset'}`;

  return baseName.toLowerCase().endsWith(extension) ? baseName : `${baseName}${extension}`;
};

const downloadFile = async (item) => {
  download({
    fileUrl: item.url,
    fileName: item.name,
  });
};
